<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("issue.download_title") }}</h1>
    <form>
      <div>
        <b-card :title="this.$i18n.t('issue.print_info')" class="w-50">
          <div style="inline-block">
            <label class="col-sm-3" style="vertical-align:top">{{ this.$i18n.t('issue.issue_date') }}</label>
            <label class="col-xs-1" style="vertical-align:top">:</label>
            <label class="col-sm-4" style="vertical-align:top">{{ date }}</label>
            <label class="col-sm-2" style="vertical-align:top">{{ this.$i18n.t('issue.issue_qty') }}</label>
            <label class="col-xs-1" style="vertical-align:top">:</label>
            <label class="col-sm-2" style="vertical-align:top">{{ issuer }}</label>
          </div>
          <div style="inline-block">
            <label class="col-sm-3" style="vertical-align:top">{{ this.$i18n.t('issue.model') }}</label>
            <label class="col-xs-1" style="vertical-align:top">:</label>
            <label class="col-sm-8" style="vertical-align:top">{{ code }}</label>
          </div>
          <div style="inline-block">
            <label class="col-sm-3" style="vertical-align:top">{{ this.$i18n.t('issue.note') }}</label>
            <label class="col-xs-1" style="vertical-align:top">:</label>
            <label class="col-sm-8" style="vertical-align:top">{{ note }}</label>
          </div>
        </b-card>
        <b-card :title="this.$i18n.t('issue.print_condition')" class="w-50">
          <b-form-group
            id="type"
            label-cols-sm="4"
            label-cols-lg="4"
            :label="this.$i18n.t('issue.barcode_kind')"
            label-for="input-horizontal"
          >
            <b-form-select v-model="selected" :options="options" class="mb-3"></b-form-select>
          </b-form-group>
          <b-form-group
            id="qty"
            label-cols-sm="4"
            label-cols-lg="4"
            :label="this.$i18n.t('issue.col')"
            label-for="input-horizontal"
          >
            <b-form-input v-model="column" ref="inputCol" type="number" min="1" :placeholder="this.$i18n.t('issue.please_input_col')" maxlength="2" class="mb-3"></b-form-input>
          </b-form-group>
          <b-form-group
            id="note"
            label-cols-sm="4"
            label-cols-lg="4"
            :label="this.$i18n.t('issue.row')"
            label-for="input-horizontal"
          >
            <b-form-input v-model="row" ref="inputRow" type="number" min="1" :placeholder="this.$i18n.t('issue.please_input_row')" maxlength="2" class="mb-3"></b-form-input>
          </b-form-group>
          <b-form-group
            id="note"
            label-cols-sm="4"
            label-cols-lg="4"
            :label="this.$i18n.t('issue.start_pos')"
            label-for="input-horizontal"
          >
            <div class="d-flex align-items-center">
              <div class="w-50">
                <b-form-input v-model="sColumn" ref="inputSCol" type="number" :max="this.column" min="1" class="mb-3" :placeholder="this.$i18n.t('issue.start_col')" maxlength="2"></b-form-input>
              </div>
              <div class="flex-shrink-1 px-2" align="center"></div>
              <div class="w-50">
                <b-form-input v-model="sRow" ref="inputSRow" type="number" :max="this.row" min="1" class="mb-3" :placeholder="this.$i18n.t('issue.start_row')" maxlength="2"></b-form-input>
              </div>
            </div>
          </b-form-group>
          <div>
            <b-button variant="primary" @click="download" ref="btnDownload" class="float-right px-5">{{ $i18n.t("issue.print") }}</b-button>
          </div>
        </b-card>
      </div>
    </form>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'
export default {
  components: {
    confirmModal
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}

    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/common/checkLogin', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        }
      })
      .catch(res => {
        // とりあえずログイン画面へ飛ばす
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        this.$router.push('/')
      })
    // 値セット
    this.date = this.$store.store.state.date
    this.code = this.$store.store.state.code
    this.issuer = this.$store.store.state.issuer
    this.note = this.$store.store.state.note
  },
  data () {
    return {
      date: null,
      code: null,
      issuer: null,
      selected: null,
      qty: null,
      row: null,
      column: null,
      sRow: '1',
      sColumn: '1',
      note: null,
      currentPage: 1,
      perPage: 5,
      options: [
        { value: null, text: this.$i18n.t('issue.please_select_barcode_kind') },
        { value: '1', text: this.$i18n.t('issue.one_dimensional_barcode') },
        { value: '2', text: this.$i18n.t('issue.qr_code') }
      ],
      fields: [
        { key: 'issuer', label: this.$i18n.t('issue.issue_qty') },
        { key: 'date', label: this.$i18n.t('issue.issue_date') },
        { key: 'type', label: this.$i18n.t('issue.model') },
        { key: 'num', label: this.$i18n.t('issue.download_count') },
        { key: 'note', label: this.$i18n.t('issue.note') },
        { key: 'download', label: this.$i18n.t('issue.download_qty') },
        { key: 'edit', label: this.$i18n.t('issue.edit') }
      ],
      items: [
        { issuer: 40, date: 'Dickerson', type: 'Macdonald', num: 0, note: '' },
        { issuer: 21, date: 'Larsen', type: 'Shaw', num: 0, note: '' },
        { issuer: 89, date: 'Geneva', type: 'Wilson', num: 0, note: '' }
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      errMsg: null,
      errSbj: null,
      errCol: false,
      errRow: false,
      errSCol: false,
      errSRow: false
    }
  },
  methods: {
    download: function () {
      if (!this.isValid()) {
        return
      }

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      var body = {
        'mo': this.$store.store.state.downloadId,
        'row': this.row,
        'column': this.column,
        'startRow': this.sRow,
        'startColumn': this.sColumn,
        'barKind': this.selected,
        'language': this.$store.store.getters.getLang
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/issue/barcode', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            console.log(res)
            var fileName = this.$store.store.state.downloadId + '_' + this.$moment().format('YYYYMMDDHHmmss')
            console.log(fileName)
            this.downloadPdf(res.data.url, fileName)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    downloadPdf: function (url, fileName) {
      this.$axios
        .get(url, {
          responseType: 'blob',
          dataType: 'binary'
        })
        .then(res => {
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(res.data, fileName + '.pdf')
          } else {
            // for chrome, firefox
            const url = URL.createObjectURL(
              new Blob([res.data], {type: 'application/pdf'})
            )
            const linkEl = document.createElement('a')
            linkEl.href = url
            linkEl.setAttribute('download', fileName + '.pdf')
            document.body.appendChild(linkEl)
            linkEl.click()
            URL.revokeObjectURL(url)
            linkEl.parentNode.removeChild(linkEl)
          }
        })
        .catch(res => {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    isValid: function () {
      this.$refs.btnDownload.blur()
      if (this.selected == null) {
        // バーコード未選択
        this.errSbj = this.$i18n.t('issue.barcode_kind')
        this.errMsg = this.$i18n.t('issue.please_select_barcode_kind')
        this.$bvModal.show('md-err')
        return false
      } else if (this.column == null || this.column === '') {
        // 列数未入力
        this.errSbj = this.$i18n.t('issue.col')
        this.errMsg = this.$i18n.t('issue.please_input_col')
        this.$bvModal.show('md-err')
        this.errCol = true
        return false
      } else if (this.row == null || this.row === '') {
        // 行数未入力
        this.errSbj = this.$i18n.t('issue.row')
        this.errMsg = this.$i18n.t('issue.please_input_row')
        this.$bvModal.show('md-err')
        this.errRow = true
        return false
      } else if (this.sRow == null || this.sRow === '') {
        // 開始行未入力
        this.errSbj = this.$i18n.t('issue.start_row')
        this.errMsg = this.$i18n.t('issue.row_start_hissu')
        this.$bvModal.show('md-err')
        this.errSRow = true
        return false
      } else if (this.sColumn == null || this.sColumn === '') {
        // 開始列未入力
        this.errSbj = this.$i18n.t('issue.start_col')
        this.errMsg = this.$i18n.t('issue.col_start_hissu')
        this.$bvModal.show('md-err')
        this.errSCol = true
        return false
      } else if (!window.checkNum(this.column) || this.column <= 0) {
        // 1以上の数字で入力(列)
        this.errSbj = this.$i18n.t('issue.col')
        this.errMsg = this.$i18n.t('issue.err_qty_number')
        this.$bvModal.show('md-err')
        this.errCol = true
        return false
      } else if (!window.checkNum(this.row) || this.row <= 0) {
        // 1以上の数字で入力(行)
        this.errSbj = this.$i18n.t('issue.row')
        this.errMsg = this.$i18n.t('issue.err_qty_number')
        this.$bvModal.show('md-err')
        this.errRow = true
        return false
      } else if (!window.checkNum(this.sRow) || this.sRow <= 0) {
        // 1以上の数字で入力(開始行)
        this.errSbj = this.$i18n.t('issue.start_row')
        this.errMsg = this.$i18n.t('issue.err_qty_number')
        this.$bvModal.show('md-err')
        this.errSRow = true
        return false
      } else if (!window.checkNum(this.sColumn) || this.sColumn <= 0) {
        // 1以上の数字で入力(開始列)
        this.errSbj = this.$i18n.t('issue.start_col')
        this.errMsg = this.$i18n.t('issue.err_qty_number')
        this.$bvModal.show('md-err')
        this.errSCol = true
        return false
      } else if (!this.checkRowColumn()) {
        return false
      } else if (parseInt(this.column) < parseInt(this.sColumn)) {
        // 列数 < 開始列の場合
        this.errSbj = this.$i18n.t('issue.start_col')
        this.errMsg = this.$i18n.t('issue.err_scolumn_greater')
        this.$bvModal.show('md-err')
        this.errSCol = true
        return false
      } else if (parseInt(this.row) < parseInt(this.sRow)) {
        // 行数 < 開始行の場合
        this.errSbj = this.$i18n.t('issue.start_row')
        this.errMsg = this.$i18n.t('issue.err_srow_greater')
        this.$bvModal.show('md-err')
        this.errSRow = true
        return false
      } else {
        return true
      }
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
      this.inputFocus()
    },
    checkRowColumn: function () {
      if (this.selected === '1') {
        if (this.column > 4) {
          this.errSbj = this.$i18n.t('issue.col')
          this.errMsg = this.$i18n.t('issue.err_barcord_column')
          this.$bvModal.show('md-err')
          this.errCol = true
          return false
        } else if (this.row > 15) {
          this.errSbj = this.$i18n.t('issue.row')
          this.errMsg = this.$i18n.t('issue.err_barcord_row')
          this.$bvModal.show('md-err')
          this.errRow = true
          return false
        } else {
          return true
        }
      } else if (this.selected === '2') {
        if (this.column > 5) {
          this.errSbj = this.$i18n.t('issue.col')
          this.errMsg = this.$i18n.t('issue.err_qr_column')
          this.$bvModal.show('md-err')
          this.errCol = true
          return false
        } else if (this.row > 20) {
          this.errSbj = this.$i18n.t('issue.row')
          this.errMsg = this.$i18n.t('issue.err_qr_row')
          this.$bvModal.show('md-err')
          this.errRow = true
          return false
        } else {
          return true
        }
      }
    },
    inputFocus: function () {
      // エラーがあった箇所にフォーカスを当てる
      if (this.errCol === true) {
        this.$refs.inputCol.focus()
        this.errCol = false
      } else if (this.errRow === true) {
        this.$refs.inputRow.focus()
        this.errRow = false
      } else if (this.errSCol === true) {
        this.$refs.inputSCol.focus()
        this.errSCol = false
      } else if (this.errSRow === true) {
        this.$refs.inputSRow.focus()
        this.errSRow = false
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/IssueDownload.vue